import type { StaticListId } from "./list";
import type { AlertsSettings } from "./list-alert";

export type StaticListSettings = {
    alerts: AlertsSettings;
};

export enum StaticListTypeEnum {
    ManuallyCreated = "ManuallyCreated",
    Shared = "Shared",
    RecentlyViewed = "RecentlyViewed",
    Crm = "crm",
}

export type StaticListType = {
    readonly userId: string;
    readonly updated?: string;
    readonly country: number;
    readonly created: string;
    readonly workspaceId: string;
    readonly friendlyName: string;
    readonly opportunityListId: StaticListId;
    readonly isSubscriptionActive: boolean;
    readonly opportunities: readonly string[];
    readonly settings: StaticListSettings;
    readonly listType: StaticListTypeEnum;
};
